import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QuestionCircleFilled } from "@ant-design/icons";
import { Tag } from "antd";
import { __ } from "../utils/i18n.js";
const LearnMoreTag = ({ url, style = undefined, label = __("Learn more") })=>{
    const useStyle = {
        cursor: "pointer",
        ...style
    };
    return /*#__PURE__*/ _jsxs(Tag, {
        style: useStyle,
        onClick: ()=>window.open(url, "_blank"),
        children: [
            /*#__PURE__*/ _jsx(QuestionCircleFilled, {}),
            " ",
            label
        ]
    });
};
export { LearnMoreTag };
